/*** IMPORTS FROM imports-loader ***/
var define = false;

export var createSignalIfSupported = function () {
    if (typeof AbortController === 'undefined')
        return { controller: false, signal: false };
    var controller = new AbortController();
    var signal = controller.signal;
    return { controller: controller, signal: signal };
};
//# sourceMappingURL=createSignalIfSupported.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/link/http/createSignalIfSupported.js
// module id = 746
// module chunks = 0